<div *ngIf="!connected">
  <div class="info">
    <div class="POS-logo" style="height: 45px; width: 100px; background-size: contain; background-repeat: no-repeat; "
         [ngStyle]="{'background-image': 'url(../../../../../../assets/pos/heartlandretail-logo.svg)'}" ></div>
    <!-- <div class="pos-title">Heartlands</div> -->
    <div class="write-up">

    </div>
  </div>
</div>

<div *ngIf="busy" style="display: block; margin-left: auto;text-align: right;">
  <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" fill="transparent"
                     animationDuration=".5s">
  </p-progressSpinner>
</div>


<div *ngIf="connected" class="margin-top-16">
  <div style="font-size: 13px; text-align: center;">{{'onboarding.messages.pos_connected_info' | translate}}</div>
  <app-heartlands-defaults *ngIf="connected" [partner]="partner" ></app-heartlands-defaults>
</div>
